import { isEmpty, toString } from 'lodash';
import { useState } from 'react';
import { InputWidget } from 'src/components/widget';
import { lang } from 'src/utils';

import { SimpleDialog } from '../simpleDialog';
import { CreateVariationModalProps } from './CreateVariationModal.interface';

export const CreateVariationModal = (props: CreateVariationModalProps) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  const onClickConfirm = () => {
    if (isEmpty(toString(name).trim())) {
      setError('Variation name is required');
    } else {
      props.onClickConfirm(toString(name).trim());
    }
  };

  return (
    <SimpleDialog
      open={props.open}
      cancelText={lang.cancel}
      confirmText={lang.confirm}
      title={`${lang.createVariationModal.title}\n${props.parentAssemblyName}`}
      subTitle={lang.createVariationModal.subTitle}
      onClose={props.onClickCancel}
      onClickCancel={props.onClickCancel}
      modalSize="sm"
      onClickConfirm={onClickConfirm}>
      <InputWidget
        label="Set variation name"
        value={name}
        onChange={(value) => setName(toString(value))}
        hasError={!isEmpty(error)}
        error={error}
      />
    </SimpleDialog>
  );
};
